import Vue from 'vue'
import DashboardPlugin from './material-dashboard'
import currencyFilter from './filters/currency.filter'
import Request from '@/services/apiConfig'
// Plugins
import App from './App.vue'
import VueTheMask from 'vue-the-mask'
import Chartist from 'chartist'
// router setup
import router from './routes/router'
import yearsFilter from './filters/years.filter'
import percentageFilter from './filters/percentage.filter'
import store from './store'
import dateFilter from './filters/date.filter'
import statusFilter from './filters/status.filter'
import roleFilter from './filters/role.filter'
import VueAnalytics from 'vue-analytics'

// plugin setup
Vue.use(DashboardPlugin)
Vue.use(VueTheMask)
//filter setup

Vue.filter('currency', currencyFilter)
Vue.filter('year', yearsFilter)
Vue.filter('status', statusFilter)
Vue.filter('date', dateFilter)
Vue.filter('percent', percentageFilter)
Vue.filter('role', roleFilter)

// global library setup
Vue.prototype.$Chartist = Chartist

Vue.use(VueAnalytics, {
  id: 'UA-114290515-1',
  disabled: true,
  router,
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!store.getters.loggedIn) {
      next({
        name: 'login',
      })
    } else {
      next()
    }
  } else if (to.matched.some(record => record.meta.requiresVisitor)) {
    if (store.getters.loggedIn) {
      next({
        name: 'Lista zamówień',
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

window.$request = new Request(store, router)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  store,
  router,
})
